{
  "next": "Weiter",
  "previous": "Zurück"
}
